import React, { useEffect } from 'react';

// Utils:
import { handleFetchError } from 'utilities/utils';
import { useErrorHandler } from 'react-error-boundary';

const TextContent = ({ currentTab, setTableData }) => {
    // // Hooks // //
    const handleError = useErrorHandler();

    // // Effects // //
    useEffect(() => {
        // Set table layers when this component mounts
        fetch(currentTab.url)
            .then(handleFetchError)
            .then((res) => res.json())
            .then(setTableData)
            .catch(handleError);
    }, [currentTab.url, setTableData, handleError]);

    // // Render // //
    return (
        <div className="text-content-container">
            <h1 className="text-content-header">{currentTab.textHeader}</h1>
            <br />
            <h6 className="text-content-sub-header">
                {currentTab.textSubheading}
            </h6>
            <p>{currentTab.textBody}</p>
        </div>
    );
};

export default TextContent;
